import { render, staticRenderFns } from "./ManageCertProfessionalFormGroup.vue?vue&type=template&id=32e1380b&scoped=true&"
import script from "./ManageCertProfessionalFormGroup.vue?vue&type=script&lang=js&"
export * from "./ManageCertProfessionalFormGroup.vue?vue&type=script&lang=js&"
import style0 from "./ManageCertProfessionalFormGroup.vue?vue&type=style&index=0&id=32e1380b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e1380b",
  null
  
)

/* custom blocks */
import block0 from "@/locales/pages/manage-cert/components/ManageCertProfessionalFormGroup.json?vue&type=custom&index=0&blockType=i18n&issuerPath=E%3A%5Capp%5CJenkins%5Cworkspace%5CAll_IaaS_Farm%5C0%20nextoreV3bdclient_build%5Csrc%5Csrc%5Cpages%5Cmanage-cert%5Ccomponents%5CManageCertProfessionalFormGroup.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports